{
  "name": "packaging-cockpit",
  "title": "Packaging Cockpit",
  "version": "2.24.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=local --ssl --ssl-cert %APPDATA%\\ASP.NET\\https\\paco-dev.pem --ssl-key %APPDATA%\\ASP.NET\\https\\paco-dev.key --host=127.0.0.1",
    "start-dev": "ng serve --ssl --ssl-cert %APPDATA%\\ASP.NET\\https\\paco-dev.pem --ssl-key %APPDATA%\\ASP.NET\\https\\paco-dev.key --host=127.0.0.1",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.14",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.14",
    "@angular/compiler": "^18.2.14",
    "@angular/core": "^18.2.14",
    "@angular/forms": "^18.2.14",
    "@angular/material": "^18.2.14",
    "@angular/material-moment-adapter": "^18.2.14",
    "@angular/platform-browser": "^18.2.14",
    "@angular/platform-browser-dynamic": "^18.2.14",
    "@angular/router": "^18.2.14",
    "@highcharts/map-collection": "^2.3.1",
    "@jsverse/transloco": "^7.6.1",
    "highcharts": "^11.3.0",
    "highcharts-angular": "^4.0.1",
    "marked": "^12.0.0",
    "moment": "^2.30.1",
    "ngx-bootstrap": "^18.1.3",
    "ngx-lightbox": "^3.0.0",
    "ngx-markdown": "^18.1.0",
    "ngx-spinner": "^18.0.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.21",
    "@angular/cli": "^18.2.21",
    "@angular/compiler-cli": "^18.2.14",
    "@angular/language-service": "^18.2.14",
    "@angular/localize": "^18.2.14",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.14.8",
    "angular-eslint": "18.4.3",
    "eslint": "^9.15.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "3.6.2",
    "typescript": "~5.5.2",
    "typescript-eslint": "8.16.0"
  }
}
